//Equipment Constants
export const EQUIPMENT_MAX_QUANTITY = 600;

export const LOAD_MANAGER_TI_HI_FEATURE_KEY = 'load-manager-ti-hi'
